import { Outlet } from 'react-router-dom';

import NoCollaboratorsAlert from 'src/alerts/noCollaboratorsAlert';
import DisabledSection from 'src/components/sections/disabledSection';
import useHasUserQuoteRoleReadOnly from 'src/hooks/useHasUserQuoteRoleReadOnly';
import { useFullProject } from 'src/project/state/hook';

const ProjectPage = () => {
    const project = useFullProject();
    const hasInvitedUsers = project.members?.length > 1;
    const hasReadOnly = useHasUserQuoteRoleReadOnly();
    return (
        <DisabledSection disabled={hasReadOnly}>
            {!hasInvitedUsers && (
                <NoCollaboratorsAlert sx={{ m: 2 }} userManagementRoute="user-management" />
            )}
            <Outlet />
        </DisabledSection>
    );
};

export default ProjectPage;
